import React from "react";

export const LogementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none">
      <path
        d="M18.9999 6.79078C13.5729 6.79078 8.97206 10.3316 7.38317 15.2299C7.32013 15.4243 7.11145 15.5308 6.91708 15.4677C6.72269 15.4047 6.61624 15.196 6.67929 15.0016C8.36423 9.80713 13.2429 6.05078 18.9999 6.05078C25.3952 6.05078 30.7072 10.6863 31.7603 16.7808H33.4299C33.5795 16.7808 33.7144 16.8709 33.7717 17.0092C33.829 17.1475 33.7973 17.3066 33.6915 17.4124L31.8415 19.2624C31.7721 19.3318 31.678 19.3708 31.5799 19.3708C31.4818 19.3708 31.3876 19.3318 31.3183 19.2624L29.4683 17.4124C29.3237 17.2679 29.3237 17.0336 29.4682 16.8892C29.5493 16.8081 29.6586 16.7725 29.7645 16.7824C29.7759 16.7813 29.7875 16.7808 29.7993 16.7808H31.0086C29.9649 11.0974 24.985 6.79078 18.9999 6.79078Z"
        fill="#2481A6"
      />
      <path
        d="M19.0002 31.2089C24.4271 31.2089 29.028 27.6681 30.6169 22.7698C30.68 22.5754 30.8886 22.4689 31.083 22.532C31.2774 22.595 31.3838 22.8037 31.3208 22.9981C29.6359 28.1926 24.7572 31.9489 19.0002 31.9489C12.6049 31.9489 7.29285 27.3134 6.23979 21.2189H4.5702C4.42057 21.2189 4.28564 21.1288 4.22836 20.9905C4.17111 20.8522 4.20276 20.6931 4.30858 20.5873L6.15858 18.7373C6.22795 18.6679 6.32208 18.6289 6.4202 18.6289C6.51833 18.6289 6.61242 18.6679 6.68183 18.7373L8.53183 20.5873C8.63765 20.6931 8.66932 20.8522 8.61205 20.9905C8.55477 21.1288 8.41987 21.2189 8.2702 21.2189H6.99145C8.03522 26.9023 13.0151 31.2089 19.0002 31.2089Z"
        fill="#2481A6"
      />
      <path
        d="M19.9378 11.5266C19.371 11.1318 18.6293 11.1318 18.0624 11.5266L10.7637 16.6099C10.3578 16.8927 10.1201 17.3633 10.1201 17.8605C10.1201 19.0377 11.4011 19.8034 12.3952 19.111L18.4853 14.8694C18.798 14.6516 19.2022 14.6516 19.5149 14.8694L25.6051 19.111C26.5991 19.8034 27.8801 19.0377 27.8801 17.8605C27.8801 17.3633 27.6424 16.8927 27.2365 16.61L19.9378 11.5266Z"
        fill="#2481A6"
      />
      <path
        d="M12.3018 19.9899V24.3426C12.3018 25.2723 13.0515 26.0297 13.981 26.0297H24.0184C24.948 26.0297 25.6976 25.2723 25.6976 24.3426V19.9899C25.5234 19.9251 25.3505 19.8351 25.1817 19.7175L19.0916 15.4759C19.033 15.4351 18.9664 15.4351 18.9079 15.4759L12.8177 19.7175C12.6489 19.8351 12.476 19.9251 12.3018 19.9899Z"
        fill="#2481A6"
      />
    </svg>
  );
};
